import * as React from 'react'
import classNames from 'classnames'
import type { Profile } from '../user/Profile'
import { assumeExhaustion, createStringEnum } from '../../../shared/lib/typeHelpers.no-deps'

export const timelineItemIcons = createStringEnum('lightning', 'pencil', 'cube')
export type TimelineItemIcon = (typeof timelineItemIcons)[number]

export type TimelineItemPosition = 'first' | 'middle' | 'last' | 'only-child'

interface Props {
    position: TimelineItemPosition
    profile?: Profile
    aboveBox?: React.ReactNode
    displayWithBox?: boolean
    displayVerticalLine?: boolean
    icon?: TimelineItemIcon
    besideCircle?: React.ReactNode
    belowCircle?: React.ReactNode
    onCircleClick?: () => void
}

export class TimelineItem extends React.Component<Props, {}> {
    public render() {
        const { position, displayWithBox } = this.props

        return (
            <div className="AppCore__ui__TimelineItem">
                {this.props.displayVerticalLine !== false && (
                    <div className={classNames('AppCore__ui__TimelineItem__line', position)} />
                )}
                {this.props.children || (
                    <div className={classNames('AppCore__ui__TimelineItem__content', { box: displayWithBox })}>
                        {this.props.aboveBox}
                        <div className="AppCore__ui__TimelineItem__topRow">
                            <div className="AppCore__ui__TimelineItem__circle">
                                {this.renderProfile() ?? this.renderIcon() ?? (
                                    <div className="AppCore__ui__TimelineItem__fallback-circle" />
                                )}
                            </div>
                            {this.props.besideCircle}
                        </div>
                        {this.props.belowCircle}
                    </div>
                )}
            </div>
        )
    }

    private renderProfile() {
        const { profile } = this.props

        if (profile == null) return null

        if (profile?.isDeleted) {
            return <div className="AppCore__ui__TimelineItem__fallback-circle" />
        }

        return (
            <zaptic-profile-circle
                class={classNames('AppCore__ui__TimelineItem__profile-circle', {
                    'AppCore__ui__TimelineItem__profile-circle--link': this.props.onCircleClick,
                })}
                name={profile.name}
                color={profile.profileCircleColor}
                profile-image-url={profile.profileImageUrl}
                onClick={this.props.onCircleClick}
            ></zaptic-profile-circle>
        )
    }

    private renderIcon() {
        const { icon } = this.props

        switch (icon) {
            case 'lightning':
                return <zaptic-icon icon-name="timeline-lightning"></zaptic-icon>

            case 'pencil':
                return <zaptic-icon icon-name="timeline-pencil"></zaptic-icon>

            case 'cube':
                return <zaptic-icon icon-name="timeline-cube"></zaptic-icon>

            default:
                assumeExhaustion(icon)
                return null
        }
    }
}

export function timelinePositionFromIndex(index: number, length: number): TimelineItemPosition {
    if (length === 1) return 'only-child'
    if (index === 0) return 'first'
    if (index === length - 1) return 'last'
    return 'middle'
}
